/**
 * Tipos de ordenação disponíveis para dívidas
 */
export enum TipoOrdenacao {
  /** Ordenação conforme ordem salva na sessionStorage */
  ORDEM_SALVA = 'ORDEM_SALVA',
  /** Ordenação por credores de maior receita */
  MAIOR_RECEITA = 'MAIOR_RECEITA',
  /** Ordenação por ordem de chegada (sem ordenação especial) */
  ORDEM_CHEGADA = 'ORDEM_CHEGADA',
  /** Ordenação baseada na modelagem Acerto (payload do backend de ordenação) */
  MODELAGEM_ACERTO = 'MODELAGEM_ACERTO',
}
